import {
    wfsService,
    WfsServiceResponse,
    WfsServiceServiceParams,
} from "../../api/api-packages/wfs-service/wfsService.service";
import EnvParamsRetriever from "../../common/util/EnvParamsRetriever";
import { getStore } from "../../../MapStore2/web/client/utils/StateUtils";
import React from "react";
import { Feature, FeatureCollection } from "../../core/geo/types";
import { EditFeatureOptions, EditFeatureState } from "../redux";
import { Bbox } from "../../rootState";
import { reprojectBbox } from "../../../MapStore2/web/client/utils/CoordinatesUtils";
import { Projection } from "../../common/types";

export interface FollowGeoBorderDispatchProps {
    wfsService: (requestParams: WfsServiceServiceParams) => Promise<WfsServiceResponse>;
    selectFeatureForEditing: (features: FeatureCollection, options: EditFeatureOptions) => void;
    saveGeoBorders: (geoBorders: Feature[]) => void;
}

export interface FollowGeoBorderStateProps {
    isActive: boolean;
    editFeature: EditFeatureState;
    bbox?: Bbox;
}

export const FollowGeoBorder = (props: FollowGeoBorderStateProps & FollowGeoBorderDispatchProps) => {
    const { isActive, selectFeatureForEditing, editFeature, bbox, saveGeoBorders } = props;

    React.useEffect(() => {
        const getBorders = async () => {
            if (editFeature.editedFeatures) {
                selectFeatureForEditing(editFeature.editedFeatures, { ...editFeature.options, editPaused: true });
            }
            const reprojected = reprojectBbox(bbox!.bounds, bbox!.crs, Projection.EPSG_4326);

            const borders = await wfsService({
                typeName: "avitech:Geoborder",
                ENV: encodeURIComponent(
                    EnvParamsRetriever.getWorkspaceEnvParams(getStore().getState()).toRequestParams()
                ),
                bbox: reprojected + "," + Projection.EPSG_4326,
            });
            if (editFeature.editedFeatures) {
                saveGeoBorders(borders.features);
                selectFeatureForEditing(editFeature.editedFeatures, {
                    ...editFeature.options,
                    geoBorders: borders.features,
                    editPaused: false,
                });
            }
        };
        if (isActive) {
            getBorders();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, bbox]);

    return null;
};
